// Gift modal (non-module)
(function () {
  const MODAL_ID = 'giftModal';
  const OVERLAY_ID = 'giftModalOverlay';
  const BTN_ID = 'giftBtn';
  const EBOOK_URL = 'https://pub-00e64b852dc04e3a8f102fa3d81f8bda.r2.dev/Ebook-Gestion-de-Riesgo-MDFX.pdf';
  const DISCOUNT_OVERLAY_ID = 'discountModalOverlay';
  const DISCOUNT_CODE = 'TFX20';

  function getUserPlan() {
    try { return (localStorage.getItem('userPlan') || 'free').toLowerCase(); } catch (e) { return 'free'; }
  }

  function getUserType() {
    try { return (localStorage.getItem('userType') || 'user').toLowerCase(); } catch (e) { return 'user'; }
  }

  function hasUnlimitedAccess() {
    const plan = getUserPlan();
    const type = getUserType();
    return type === 'admin' || plan === 'unlimited';
  }

  function isDemoActive() {
    try {
      return typeof window.isDemoMode === 'function' && window.isDemoMode();
    } catch (e) {
      return false;
    }
  }

  function updateGiftCountBadge() {
    const badge = document.getElementById('giftCount');
    if (!badge) return;
    const count = hasUnlimitedAccess() ? 2 : 1;
    badge.textContent = String(count);
  }

  function ensureModal() {
    if (document.getElementById(OVERLAY_ID)) return;

    const overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'fixed inset-0 bg-black/70 backdrop-blur-sm z-[10000] hidden flex items-center justify-center p-4';

    const modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'w-full max-w-sm sm:max-w-md bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 border border-slate-700/60 rounded-2xl shadow-2xl p-5 sm:p-6 relative';

    modal.innerHTML = `
      <button id="giftModalClose" class="absolute top-3 right-3 w-9 h-9 rounded-full bg-slate-800/80 hover:bg-slate-700 text-slate-400 hover:text-white transition-all flex items-center justify-center" aria-label="Cerrar">
        ✕
      </button>
      <div class="flex items-center gap-3 mb-4">
        <div class="svg_container w-12 h-12 rounded-xl bg-gradient-to-br from-fuchsia-500/15 via-pink-500/15 to-purple-500/15 border border-pink-500/25 flex items-center justify-center">
          <div class="svg_gift_icon w-6 h-6 text-pink-200">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" viewBox="0 0 18 18">
              <defs>
                <clipPath id="gift_svg_clip">
                  <rect x="0" y="0" width="18" height="18" rx="0"></rect>
                </clipPath>
              </defs>
              <g clip-path="url(#gift_svg_clip)">
                <g>
                  <path d="M5.31818,1.63636C4.99269,1.63636,4.68052,1.76567,4.45037,1.99582C4.22021,2.22598,4.09091,2.53815,4.09091,2.86364C4.09091,3.18913,4.22021,3.50129,4.45037,3.73145C4.68052,3.9616,4.99269,4.09091,5.31818,4.09091C5.31818,4.09091,7.89874,4.09091,7.89874,4.09091C7.79887,3.82959,7.67243,3.54225,7.51605,3.25793C7.00144,2.32228,6.29501,1.63636,5.31818,1.63636C5.31818,1.63636,5.31818,1.63636,5.31818,1.63636ZM8.18182,5.72727C8.18182,5.72727,8.18182,8.18182,8.18182,8.18182C8.18182,8.18182,1.63636,8.18182,1.63636,8.18182C1.63636,8.18182,1.63636,5.72727,1.63636,5.72727C1.63636,5.72727,8.18182,5.72727,8.18182,5.72727C8.18182,5.72727,8.18182,5.72727,8.18182,5.72727ZM2.73086,4.09091C2.55062,3.71092,2.45455,3.29223,2.45455,2.86364C2.45455,2.10415,2.75625,1.37577,3.29329,0.838743C3.83032,0.301704,4.5587,0,5.31818,0C7.20499,0,8.33948,1.35954,8.94985,2.46934C8.96686,2.50028,8.98355,2.53119,9,2.56206C9.01645,2.53119,9.03314,2.50028,9.05015,2.46934C9.66052,1.35954,10.795,0,12.6818,0C13.4413,0,14.1697,0.301704,14.7067,0.838743C15.2438,1.37577,15.5455,2.10415,15.5455,2.86364C15.5455,3.29223,15.4494,3.71092,15.2692,4.09091C15.2692,4.09091,17.1818,4.09091,17.1818,4.09091C17.6337,4.09091,18,4.45723,18,4.90909C18,4.90909,18,9,18,9C18,9.45188,17.6337,9.81818,17.1818,9.81818C17.1818,9.81818,16.3636,9.81818,16.3636,9.81818C16.3636,9.81818,16.3636,17.1818,16.3636,17.1818C16.3636,17.6337,15.9973,18,15.5455,18C15.5455,18,2.45455,18,2.45455,18C2.00268,18,1.63636,17.6337,1.63636,17.1818C1.63636,17.1818,1.63636,9.81818,1.63636,9.81818C1.63636,9.81818,0.818182,9.81818,0.818182,9.81818C0.366312,9.81818,0,9.45188,0,9C0,9,0,4.90909,0,4.90909C0,4.45723,0.366312,4.09091,0.818182,4.09091C0.818182,4.09091,2.73086,4.09091,2.73086,4.09091C2.73086,4.09091,2.73086,4.09091,2.73086,4.09091ZM3.27273,9.81818C3.27273,9.81818,3.27273,16.3636,3.27273,16.3636C3.27273,16.3636,8.18182,16.3636,8.18182,16.3636C8.18182,16.3636,8.18182,9.81818,8.18182,9.81818C8.18182,9.81818,3.27273,9.81818,3.27273,9.81818C3.27273,9.81818,3.27273,9.81818,3.27273,9.81818ZM9.81818,9.81818C9.81818,9.81818,9.81818,16.3636,9.81818,16.3636C9.81818,16.3636,14.7273,16.3636,14.7273,16.3636C14.7273,16.3636,14.7273,9.81818,14.7273,9.81818C14.7273,9.81818,9.81818,9.81818,9.81818,9.81818C9.81818,9.81818,9.81818,9.81818,9.81818,9.81818ZM16.3636,8.18182C16.3636,8.18182,9.81818,8.18182,9.81818,8.18182C9.81818,8.18182,9.81818,5.72727,9.81818,5.72727C9.81818,5.72727,16.3636,5.72727,16.3636,5.72727C16.3636,5.72727,16.3636,8.18182,16.3636,8.18182C16.3636,8.18182,16.3636,8.18182,16.3636,8.18182ZM12.6818,4.09091C13.0073,4.09091,13.3195,3.9616,13.5497,3.73145C13.7798,3.50129,13.9091,3.18913,13.9091,2.86364C13.9091,2.53815,13.7798,2.22598,13.5497,1.99582C13.3195,1.76567,13.0073,1.63636,12.6818,1.63636C11.705,1.63636,10.9986,2.32228,10.4839,3.25793C10.3276,3.54225,10.2012,3.82959,10.1013,4.09091C10.1013,4.09091,12.6818,4.09091,12.6818,4.09091C12.6818,4.09091,12.6818,4.09091,12.6818,4.09091Z" fill-rule="evenodd" fill-opacity="1" fill="currentColor"></path>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div>
          <h3 class="text-xl font-bold text-white">Regalos y Bonus</h3>
          <p class="text-sm text-slate-400">Contenido exclusivo para usuarios UNLIMITED</p>
        </div>
      </div>

      <div class="space-y-3">
        <div class="flex items-center justify-between p-4 rounded-xl border border-slate-700/50 bg-slate-800/30">
          <div>
            <p class="text-sm font-semibold text-white">eBook Gestión de Riesgo</p>
            <p class="text-xs text-slate-400">Guía completa en PDF</p>
          </div>
          <button id="giftDownloadEbook" class="px-4 py-2 rounded-lg font-semibold text-sm transition-all bg-cyan-600 hover:bg-cyan-700 text-white">
            Descargar
          </button>
        </div>

        <div class="flex items-center justify-between p-4 rounded-xl border border-slate-700/50 bg-slate-800/30">
          <div>
            <p class="text-sm font-semibold text-white">Descuento activo</p>
            <p class="text-xs text-slate-400">Aplica el código en tu plan PRO o UNLIMITED</p>
          </div>
          <button id="giftDiscountBtn" class="px-4 py-2 rounded-lg font-semibold text-sm transition-all bg-emerald-600 hover:bg-emerald-700 text-white">
            Reclamar
          </button>
        </div>

        <div class="flex items-center justify-between p-4 rounded-xl border border-slate-700/50 bg-slate-800/30 opacity-70">
          <div>
            <p class="text-sm font-semibold text-white">Próximos regalos</p>
            <p class="text-xs text-slate-400">Aquí irán nuevos bonus</p>
          </div>
          <span class="text-xs text-slate-500">Muy pronto</span>
        </div>
      </div>

      <div id="giftAccessNote" class="mt-4 text-xs text-slate-400"></div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });

    const closeBtn = modal.querySelector('#giftModalClose');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });

    const downloadBtn = modal.querySelector('#giftDownloadEbook');
    if (downloadBtn) {
      downloadBtn.addEventListener('click', () => {
        if (window.demoGate && window.demoGate('ebook', 'Descargar eBook')) {
          return;
        }
        if (!hasUnlimitedAccess()) {
          if (window.showAlert) {
            window.showAlert('Actualiza a UNLIMITED', 'Este regalo está disponible solo para UNLIMITED.', 'warning');
          }
          return;
        }
        if (window.downloadEbook && typeof window.downloadEbook === 'function') {
          window.downloadEbook();
          return;
        }
        try { window.open(EBOOK_URL, '_blank'); } catch (e) {}
      });
    }

    const discountBtn = modal.querySelector('#giftDiscountBtn');
    if (discountBtn) {
      discountBtn.addEventListener('click', () => {
        openDiscountModal();
      });
    }
  }

  function updateAccessNote() {
    const note = document.getElementById('giftAccessNote');
    const btn = document.getElementById('giftDownloadEbook');
    if (!note) return;
    if (isDemoActive()) {
      note.textContent = 'En modo DEMO no se permite descargar el eBook.';
      note.className = 'mt-4 text-xs text-amber-400';
      if (btn) {
        btn.disabled = true;
        btn.className = 'px-4 py-2 rounded-lg font-semibold text-sm transition-all bg-slate-700/60 text-slate-400 cursor-not-allowed';
      }
      return;
    }
    if (hasUnlimitedAccess()) {
      note.textContent = 'Acceso UNLIMITED activo.';
      note.className = 'mt-4 text-xs text-emerald-400';
      if (btn) {
        btn.disabled = false;
        btn.className = 'px-4 py-2 rounded-lg font-semibold text-sm transition-all bg-cyan-600 hover:bg-cyan-700 text-white';
      }
    } else {
      note.textContent = 'Solo UNLIMITED puede descargar estos regalos.';
      note.className = 'mt-4 text-xs text-amber-400';
      if (btn) {
        btn.disabled = true;
        btn.className = 'px-4 py-2 rounded-lg font-semibold text-sm transition-all bg-slate-700/60 text-slate-400 cursor-not-allowed';
      }
    }
  }

  function openModal() {
    ensureModal();
    updateAccessNote();
    const overlay = document.getElementById(OVERLAY_ID);
    if (overlay) overlay.classList.remove('hidden');
  }

  function closeModal() {
    const overlay = document.getElementById(OVERLAY_ID);
    if (overlay) overlay.classList.add('hidden');
  }

  function initGiftButton() {
    const btn = document.getElementById(BTN_ID);
    if (!btn) return;
    updateGiftCountBadge();
    btn.addEventListener('click', (e) => {
      try { e.preventDefault(); } catch (err) {}
      try { e.stopPropagation(); } catch (err) {}
      try { e.stopImmediatePropagation(); } catch (err) {}
      openModal();
    });
  }

  function ensureDiscountModal() {
    if (document.getElementById(DISCOUNT_OVERLAY_ID)) return;

    const styleId = 'discount-modal-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .confetti-piece{position:absolute;width:8px;height:12px;opacity:.9;animation:confetti-fall 1600ms linear forwards;}
        @keyframes confetti-fall{0%{transform:translateY(-10px) rotate(0deg);opacity:1;}100%{transform:translateY(280px) rotate(260deg);opacity:0;}}
      `;
      document.head.appendChild(style);
    }

    const overlay = document.createElement('div');
    overlay.id = DISCOUNT_OVERLAY_ID;
    overlay.className = 'fixed inset-0 bg-black/70 backdrop-blur-sm z-[10001] hidden flex items-center justify-center p-4';

    const modal = document.createElement('div');
    modal.className = 'w-full max-w-sm sm:max-w-md bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 border border-slate-700/60 rounded-2xl shadow-2xl p-5 sm:p-6 relative overflow-hidden';

    modal.innerHTML = `
      <button id="discountModalClose" class="absolute top-3 right-3 w-9 h-9 rounded-full bg-slate-800/80 hover:bg-slate-700 text-slate-400 hover:text-white transition-all flex items-center justify-center" aria-label="Cerrar">✕</button>
      <div class="flex items-center gap-3 mb-3">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500/20 to-cyan-500/20 border border-emerald-500/30 flex items-center justify-center">
          <svg class="w-6 h-6 text-emerald-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14l2 2 4-4m-6 6h8a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v9a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-white">Descuento activo</h3>
          <p class="text-sm text-slate-400">Aplica este código en tu compra</p>
        </div>
      </div>

      <div class="bg-slate-800/40 border border-slate-700/50 rounded-xl p-4">
        <p class="text-xs text-slate-400 mb-2">Código de descuento</p>
        <div class="flex items-center justify-between gap-2">
          <span id="discountCodeValue" class="px-3 py-2 bg-slate-900/70 border border-slate-700/50 rounded-lg text-white font-semibold tracking-wider">${DISCOUNT_CODE}</span>
          <button id="discountCopyBtn" class="px-3 py-2 rounded-lg font-semibold text-sm bg-emerald-600 hover:bg-emerald-700 text-white">Copiar</button>
        </div>
        <p class="text-xs text-slate-400 mt-2">Válido para plan PRO o UNLIMITED.</p>
      </div>

      <div class="mt-4 text-xs text-slate-400">Úsalo en el checkout de tu plan.</div>
      <div id="confettiContainer" class="absolute inset-0 pointer-events-none"></div>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeDiscountModal();
    });

    const closeBtn = modal.querySelector('#discountModalClose');
    if (closeBtn) closeBtn.addEventListener('click', closeDiscountModal);

    const copyBtn = modal.querySelector('#discountCopyBtn');
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(DISCOUNT_CODE);
          if (window.showAlert) window.showAlert('Código copiado', `Código ${DISCOUNT_CODE} copiado al portapapeles.`, 'success');
        } catch (e) {
          if (window.showAlert) window.showAlert('Copia manual', `Código: ${DISCOUNT_CODE}`, 'info');
        }
      });
    }
  }

  function launchConfetti() {
    const container = document.getElementById('confettiContainer');
    if (!container) return;
    container.innerHTML = '';
    const colors = ['#22c55e', '#06b6d4', '#a855f7', '#f59e0b', '#f472b6'];
    for (let i = 0; i < 24; i += 1) {
      const piece = document.createElement('div');
      piece.className = 'confetti-piece';
      piece.style.left = `${Math.random() * 100}%`;
      piece.style.top = `${-10 - Math.random() * 40}px`;
      piece.style.background = colors[Math.floor(Math.random() * colors.length)];
      piece.style.transform = `rotate(${Math.random() * 360}deg)`;
      piece.style.animationDelay = `${Math.random() * 200}ms`;
      container.appendChild(piece);
    }
  }

  function openDiscountModal() {
    ensureDiscountModal();
    const overlay = document.getElementById(DISCOUNT_OVERLAY_ID);
    if (overlay) overlay.classList.remove('hidden');
    launchConfetti();
  }

  function closeDiscountModal() {
    const overlay = document.getElementById(DISCOUNT_OVERLAY_ID);
    if (overlay) overlay.classList.add('hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftButton);
  } else {
    initGiftButton();
  }

  try {
    window.addEventListener('storage', (e) => {
      if (e.key === 'userPlan' || e.key === 'userType') {
        updateGiftCountBadge();
      }
    });
  } catch (e) {}
})();
